import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22d4d008"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-name", "onContextmenu", "onClick"]
const _hoisted_2 = {
  key: 0,
  class: "iconfont icon-webicon318 layout-navbars-tagsview-ul-li-iconfont font14"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_Contextmenu = _resolveComponent("Contextmenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layout-navbars-tagsview", { 'layout-navbars-tagsview-shadow': $setup.getThemeConfig.layout === 'classic' }])
  }, [
    _createVNode(_component_el_scrollbar, {
      ref: "scrollbarRef",
      onWheel: _withModifiers($setup.onHandleScroll, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", {
          class: _normalizeClass(["layout-navbars-tagsview-ul", $setup.setTagsStyle]),
          ref: "tagsUlRef"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagsViewList, (v, k) => {
            return (_openBlock(), _createElementBlock("li", {
              key: k,
              class: _normalizeClass(["layout-navbars-tagsview-ul-li", { 'is-active': $setup.isActive(v) }]),
              "data-name": v.name,
              onContextmenu: _withModifiers(($event: any) => ($setup.onContextmenu(v, $event)), ["prevent"]),
              onClick: ($event: any) => ($setup.onTagsClick(v, k)),
              ref: 
						(el) => {
							if (el) $setup.tagsRefs[k] = el;
						}
					
            }, [
              ($setup.isActive(v))
                ? (_openBlock(), _createElementBlock("i", _hoisted_2))
                : _createCommentVNode("", true),
              (!$setup.isActive(v) && $setup.getThemeConfig.isTagsviewIcon)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: _normalizeClass(["layout-navbars-tagsview-ul-li-iconfont", v.meta.icon])
                  }, null, 2))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(v.meta.title)), 1),
              ($setup.isActive(v))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("i", {
                      class: "el-icon-refresh-right ml5",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.refreshCurrentTagsView(_ctx.$route.fullPath)), ["stop"]))
                    }),
                    (!v.meta.isAffix)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "el-icon-close layout-navbars-tagsview-ul-li-icon layout-icon-active",
                          onClick: _withModifiers(($event: any) => ($setup.closeCurrentTagsView($setup.getThemeConfig.isShareTagsView ? v.path : v.url)), ["stop"])
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (!v.meta.isAffix)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 3,
                    class: "el-icon-close layout-navbars-tagsview-ul-li-icon layout-icon-three",
                    onClick: _withModifiers(($event: any) => ($setup.closeCurrentTagsView($setup.getThemeConfig.isShareTagsView ? v.path : v.url)), ["stop"])
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true)
            ], 42, _hoisted_1))
          }), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["onWheel"]),
    _createVNode(_component_Contextmenu, {
      dropdown: _ctx.dropdown,
      ref: "contextmenuRef",
      onCurrentContextmenuClick: $setup.onCurrentContextmenuClick
    }, null, 8, ["dropdown", "onCurrentContextmenuClick"])
  ], 2))
}